import React, { type FunctionComponent } from 'react'
import { Breadcrumb, Breadcrumbs } from '@retailer-platform/shared-components'
import { useDomainMessage } from 'domains/collections/utils/domain/intl'
import { type CollectionsRoutingConfig } from 'domains/collections/types/collections.types'
import { useDomainScopedPathname } from 'domains/collections/utils/domain/routing'

interface CollectionsBreadcrumbsProps {
  routingConfig: CollectionsRoutingConfig
  baseBreadcrumbs?: React.ReactChild
}

export const CollectionsBreadcrumbs: FunctionComponent<CollectionsBreadcrumbsProps> = ({
  routingConfig,
  children,
  baseBreadcrumbs,
}) => {
  const rootText = useDomainMessage('collectionsDomain.list.title')
  const listPath = useDomainScopedPathname(routingConfig.list)

  const resolvedBaseBreadcrumbs = baseBreadcrumbs || (
    <Breadcrumb path={listPath}>{rootText}</Breadcrumb>
  )

  return (
    <Breadcrumbs>
      {resolvedBaseBreadcrumbs}
      {children}
    </Breadcrumbs>
  )
}
